<template>
  <div>
    <DecommissionChannelGrid @set-selectedRows-grid="selectedGridData" />
  </div>
</template>
<script>
import DecommissionChannelGrid from "../DecommissionChannelGrid.vue";
export default {
  name: "DecommissionChannel",
  components: {
    DecommissionChannelGrid,
  },
  methods: {
    selectedGridData(data) {
      this.$emit("selected-data", data);
      //console.log(data);
    },
  },
};
</script>